<div class="row select-row">
  <span class="Text-select">SELECT:</span>
  <select class="Select-Option" [(ngModel)]="selectedOption" (change)="onOptionChange()">
    <option value="" disabled selected hidden>Select Option</option>
    <option class="Option" *ngFor="let option of options" [value]="option.name">
      {{ option.name }}
    </option>
  </select>
</div>

<div class="row" style="margin: 0vw; padding: 0vw; display: flex; justify-content: center;" *ngIf="Upadte">
  <div class="upload-container">
    <div class="row" style="display: flex;">
      <label class="head">
        <h2>Upload QC Package</h2>
      </label>
    </div>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Reference Number</mat-label>
      <input matInput [(ngModel)]="referenceNumber" placeholder="Enter Reference Number" required
        name="referenceNumber">
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Key</mat-label>
      <input matInput [(ngModel)]="UploadKey" placeholder="Enter Reference Key" required
        name="UploadKey">
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Role</mat-label>
      <input matInput [(ngModel)]="role" placeholder="QC (Optional)" name="role">
    </mat-form-field>

    <!-- Radio Buttons Start -->
    <div style="margin: 0.5208333333333334vw 0vw;">
      <mat-radio-group [(ngModel)]="uploadType" name="uploadType" required>
        <mat-radio-button value="cv">CV</mat-radio-button>
        <mat-radio-button value="jatsxml" style="margin-left: 0.78125vw;">JATS XML</mat-radio-button>
      </mat-radio-group>
      <!-- Optional: show validation message -->
      <div *ngIf="formSubmitted && !uploadType" style="color: red; font-size: 0.6770833333333334vw;">
        Please select an upload type.
      </div>
    </div>
    <!-- Radio Buttons End -->

    <input type="file" (change)="onFileSelected($event)" accept=".zip" />

    <button mat-raised-button color="primary" (click)="uploadFile()" [disabled]="!file || !uploadType || isUploading">
      {{ isUploading ? 'Uploading...' : 'Upload' }}
    </button>

    <p *ngIf="uploadMessage" [ngClass]="{
      'success-msg': uploadMessage.startsWith('✅'),
      'error-msg': uploadMessage.startsWith('❌')}">
      {{ uploadMessage }}
    </p>

    <p *ngIf="uploadMessage" [ngClass]="{
      'success-msg': uploadMessage.startsWith('✅'),
      'error-msg': uploadMessage.startsWith('❌')}">
      {{ uploadrefmessage }}
    </p>
  </div>
</div>

<div class="row single-row" *ngIf="Single">
  <div class="download-container">
    <h2 class="download-title">Download Single File</h2>

    <input type="text" placeholder="Enter the full file path, e.g.: OPS_Editor/.../Input/filename.zip" [(ngModel)]="DownloadText" class="download-input" />

    <button type="button" class="download-button" [disabled]="isDownloading || !this.DownloadText" (click)="onClick()">
      {{ isDownloading ? 'Downloading...' : 'DOWNLOAD' }}
    </button>
  </div>
</div>

<div class="row multiple-row" *ngIf="Multiple">
  <div class="download-container-1">
    <h2 class="download-title">Download Multiple File</h2>

    <textarea class="download-input1" [(ngModel)]="DownloadTextmulti" rows="10"
      placeholder="Paste folder paths here (  comma-separated)" style="height: auto;"></textarea>

    <button type="button" class="download-button" [disabled]="isMultiDownload || !DownloadTextmulti?.trim()" (click)="OnMultiple()">
      {{ isMultiDownload ? 'Downloading...' : 'DOWNLOAD'}}
    </button>
  </div>
</div>

<div class="row single-row" *ngIf="UccDownload">
  <div class="download-container">
    <h2 class="download-title">Download UCC Single File</h2>

    <input type="text" placeholder="Enter the full file path, e.g.: Packages/.../Input/filename.zip" [(ngModel)]="DownloadUCCText" class="download-input" />

    <button type="button" class="download-button" [disabled]="isDownloading || !this.DownloadUCCText" (click)="onUCCDownloadClick()">
      {{ isDownloading ? 'Downloading...' : 'DOWNLOAD' }}
    </button>
  </div>
</div>

<div class="row multiple-row" *ngIf="UccMultiDownload">
  <div class="download-container-1">
    <h2 class="download-title">Download UCC Multiple File</h2>

    <textarea class="download-input1" [(ngModel)]="DownloadTextUCC" rows="10"
      placeholder="Paste folder paths here (comma-separated)" style="height: auto;"></textarea>

    <button type="button" class="download-button" [disabled]="isMultiDownload || !this.DownloadTextUCC" (click)="OnUccMultiple()">
      {{ isMultiDownload ? 'Downloading...' : 'DOWNLOAD'}}
    </button>
  </div>
</div>